
<script>
import http from '@/service/http'
import { mapState } from 'vuex'
export default {
  name: 'Form',
  data () {
    return {
      perfis: [{}],
      marcas: [{}],
      usuario: {
        id: '',
        perfil_id: '',
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirm_password: '',
        imagem: '',
        comissao: '',
        assinatura: '',
        cpf: '',
        rg: '',
        telefone: '',
        celular: '',
        ativo: true,
        anexos: [],
        marcas: [{}],
        parceiro_logo: '',
        parceiro_rodape: ''
      },
      progress: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      errorFile: false,
      errorFile2: false,
      errorFile3: false,
      options: {
        url: `${process.env.API_URL}/upload-image-square`,
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'usuarios',
          width: 200,
          height: 200,
          accept: 'all'
        }
      },
      options2: {
        url: `${process.env.API_URL}/upload-image-area`,
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'usuarios',
          width: 800,
          height: 600,
          accept: 'all'
        }
      },
      options3: {
        url: `${process.env.API_URL}/upload-file`,
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'usuarios',
          accept: 'all'
        }
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    }
  },
  methods: {
    totalProgress (progress, totalBytes, bytesSent) {
      this.progress = progress
    },
    complete (file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        file.addAttribute('id', xhr.response.id)
        this.usuario.imagem = xhr.response
        this.progress = 0
      }
    },
    destroyImage () {
      this.$swal({
        title: 'Atenção',
        text: `deseja excluir a imagem?`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        this.usuario.imagem = ''
      })
    },
    totalProgress2 (progress, totalBytes, bytesSent) {
      this.progress2 = progress
    },
    complete2 (file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true
      } else {
        this.errorFile2 = false
        file.addAttribute('id', xhr.response.id)
        this.usuario.assinatura = xhr.response
        this.progress2 = 0
      }
    },
    totalProgress4 (progress, totalBytes, bytesSent) {
      this.progress4 = progress
    },
    complete4 (file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true
      } else {
        this.errorFile2 = false
        file.addAttribute('id', xhr.response.id)
        this.usuario.parceiro_logo = xhr.response
        this.progress4 = 0
      }
    },
    totalProgress3 (progress, totalBytes, bytesSent) {
      this.progress3 = progress
    },
    complete3 (files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        this.usuario.anexos.push({anexo: xhr.response, legenda: files.name})
        this.$nextTick(() => {
          window.Materialize.updateTextFields()
        })
        this.progress = 0
      }
    },
    destroyAnexo (indexAnexo) {
      this.$swal({
        title: 'Atenção',
        text: `excluir uma anexo é uma operação irreversível`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        if (!this.usuario.anexos[indexAnexo].id) {
          this.usuario.anexos.splice(indexAnexo, 1)
          window.Materialize.toast('Anexo excluído!', 4000)
        } else {
          http.delete(`usuarios/anexo/${this.usuario.anexos[indexAnexo].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast('Anexo excluído!', 4000)
              this.usuario.anexos.splice(indexAnexo, 1)
            })
        }
      })
    },
    destroyImage2 () {
      this.$swal({
        title: 'Atenção',
        text: `deseja excluir a imagem?`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        this.usuario.assinatura = ''
      })
    },
    destroyImageParceiro () {
      this.$swal({
        title: 'Atenção',
        text: `deseja excluir a imagem?`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        this.usuario.parceiro_logo = ''
      })
    },
    async fecth () {
      this.clear()
      const { id } = this.$route.params
      if (id !== undefined) {
        const { data } = await http.get(`/usuarios/${id}/edit`)
        this.usuario = data.usuario
        this.usuario.marcas = data.marcasSelect
        this.perfis = data.perfis
        this.marcas = data.marcas
      } else {
        const { data } = await http.get(`/usuarios/create`)
        this.marcas = data.marcas
        this.perfis = data.perfis
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/usuarios' : `/usuarios/${this.usuario.id}`
      const { data } = await http[verb](url, this.usuario)
      if (data != null) {
        this.$emit('update-usuarios-list', { usuario: data.usuario })
        this.$router.push({ name: 'usuarios.index' })
      }
    },
    clear () {
      this.usuario = {
        id: '',
        perfil_id: '',
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirm_password: '',
        imagem: '',
        comissao: '',
        cpf: '',
        rg: '',
        telefone: '',
        celular: '',
        ativo: true,
        anexos: [],
        marcas: [{}],
        parceiro_logo: '',
        parceiro_rodape: ''
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.usuario.id === ''
    },
    api_url () {
      return process.env.UPLOADS_URL
    },
    usuarioMarcas: {
      get () {
        return this.marcas.filter(
          option => this.usuario.marcas.includes(option.id)
        )
      },
      set (newSelectedOptions) {
        this.usuario.marcas = newSelectedOptions.map(option => option.id)
      }
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">

            <div class="col s12 m6">
              <label for="perfil_id">*Perfil</label>
              <select name="perfil_id" id="perfil_id" v-validate data-vv-rules="required" v-model="usuario.perfil_id">
                <option v-for="perfil in perfis" :value="perfil.id">{{ perfil.perfil }}</option>
              </select>
              <small class="red-text">{{ errors.first('perfil_id') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12 m6">
              <input name="nome" id="nome" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('nome')}" v-model="usuario.nome">
              <label for="nome">*Nome</label>
              <small class="red-text">{{ errors.first('nome') }}</small>
            </div>

            <div class="input-field col s12 m6">
              <input name="sobrenome" id="sobrenome" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('sobrenome')}" v-model="usuario.sobrenome">
              <label for="sobrenome">*Sobrenome</label>
              <small class="red-text">{{ errors.first('sobrenome') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12 m4">
              <input name="email" id="email" type="text" v-validate data-vv-rules="required|email" :class="{invalid: errors.has('email')}" v-model="usuario.email">
              <label for="email">*E-mail</label>
              <small class="red-text">{{ errors.first('email') }}</small>
            </div>

            <div class="input-field col s12 m4">
              <input name="password" id="password" type="password" v-validate="{'required': isNew}" ref="password" :class="{invalid: errors.has('password')}" v-model="usuario.password">
              <label for="password">Senha</label>
              <small class="red-text">{{ errors.first('password') }}</small>
            </div>

            <div class="input-field col s12 m4">
              <input name="confirm_password" id="confirm_password" type="password" v-validate data-vv-rules="confirmed:password" :class="{invalid: errors.has('confirm_password')}" v-model="usuario.confirm_password">
              <label for="confirm_password">Confirmar senha</label>
              <small class="red-text">{{ errors.first('confirm_password') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12 m3">
              <input name="telefone" id="telefone" type="text" v-mask="'(99) 9999-9999'" v-validate data-vv-rules="min:14" :class="{invalid: errors.has('telefone')}" v-model="usuario.telefone">
              <label for="telefone">Telefone</label>
              <small class="red-text">{{ errors.first('telefone') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="celular" id="celular" type="text" v-mask="'(99) 99999-9999'"
                     v-validate data-vv-rules="min:15"
                     :class="{invalid: errors.has('celular')}" v-model="usuario.celular">
              <label for="celular">Celular</label>
              <small class="red-text">{{ errors.first('celular') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="rg" id="rg" type="text" v-model="usuario.rg">
              <label for="rg">RG</label>
              <small class="red-text">{{ errors.first('rg') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="cpf" id="cpf" type="text" v-mask="'999.999.999-99'" v-validate
                     data-vv-rules="min:14" :class="{invalid: errors.has('cpf')}"
                     v-model="usuario.cpf">
              <label for="cpf">CPF</label>
              <small class="red-text">{{ errors.first('cpf') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12 m3">
              <input name="comissao" id="comissao" type="number" step="0.01" :class="{invalid: errors.has('comissao')}"
                    v-model="usuario.comissao">
              <label for="comissao">% de Comissão</label>
              <small class="red-text">{{ errors.first('comissao') }}</small>
            </div>
          </div>
            

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options" :on-complete="complete" :on-total-progress="totalProgress">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card">
                          <span class="card-title">Avatar</span>
                          <div class="center-align" style="height: 100px; width: 100%;">
                            <img v-if="usuario.imagem" :src="`${api_url}/usuarios/${usuario.imagem}`" style="max-width: 90%; max-height: 80px;">
                            <div v-else>
                              <img  src="../../../assets/images/thumbupload.jpg" style="max-width: 90%; max-height: 50px;">
                              <br clear="all" />
                              <small class="center-align">clique para inserir uma imagem</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress}%`"></div>
                      </div>
                      <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="usuario.imagem" class="center-align"><i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i></div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

            <div class="col s12 m3">

              <vue-clip :options="options2" :on-complete="complete2" :on-total-progress="totalProgress2">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card">
                          <span class="card-title">Assinatura</span>
                          <div class="center-align" style="height: 100px; width: 100%;">
                            <img v-if="usuario.assinatura" :src="`${api_url}/usuarios/${usuario.assinatura}`" style="max-width: 90%; max-height: 80px;">
                            <div v-else>
                              <img  src="../../../assets/images/thumbupload.jpg" style="max-width: 90%; max-height: 50px;">
                              <br clear="all" />
                              <small class="center-align">clique para inserir uma imagem</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress2}%`"></div>
                      </div>
                      <div v-if="errorFile2" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="usuario.assinatura" class="center-align"><i class="material-icons pointer" @click.prevent="destroyImage2()">delete_forever</i></div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

          </div>

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options3" :on-complete="complete3" :on-total-progress="totalProgress3">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card center">
                          <span class="card-title">Anexo</span>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress3}%`"></div>
                      </div>
                      <div v-if="errorFile3" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="usuario.anexo" class="center-align">
                        <i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i>
                        <a :href="`${api_url}/usuarios/${usuario.anexo}`" target="_blank"><i
                          class="material-icons pointer">search</i></a>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

          </div>

          <div class="row">
            <div class="col s12 m6 center-align" v-for="(anexo, indexAnexo) in usuario.anexos">
              <div class="row">
                <div class="col s12 m2">
                  <br>
                  <a :href="`${api_url}/usuarios/${anexo.anexo}`" target="_blank"><i class="material-icons">file_download</i></a>
                </div>
                <div class="input-field col s12 m7">
                  <input name="legenda" :id="`legenda-${indexAnexo}`" type="text"
                         v-model="anexo.legenda"/>
                  <label :for="`legenda-${indexAnexo}`">Legenda</label>
                </div>
                <div class="col s12 m2">
                  <br>
                  <a href="#" @click.prevent="destroyAnexo(indexAnexo)">
                    <i class="material-icons red-text">delete_forever</i>
                  </a>
                </div>
              </div>
              <br clear="all"/>
            </div>
          </div>

          <div class="row">
            <div class="col s12">
              <p><strong>Parceiro</strong></p>
            </div>
          </div>
          <div class="row">

            <div class="col s12 m6">
              <label>Marcas (Deixe vazio para liberar todas as marcas)</label>
              <multiselect multiple placeholder="Selecione" :closeOnSelect="false" v-model="usuario.marcas" label="marca" track-by="id" :options="marcas"></multiselect>
            </div>

            <div class="input-field col s12 m6">
              <input name="parceiro_rodape" id="parceiro_rodape" type="text" :class="{invalid: errors.has('parceiro_rodape')}" v-model="usuario.parceiro_rodape">
              <label for="parceiro_rodape">Texto Rodapé</label>
              <small class="red-text">{{ errors.first('parceiro_rodape') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options" :on-complete="complete4" :on-total-progress="totalProgress4">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card">
                          <span class="card-title">Logo</span>
                          <div class="center-align" style="height: 100px; width: 100%;">
                            <img v-if="usuario.parceiro_logo" :src="`${api_url}/usuarios/${usuario.parceiro_logo}`" style="max-width: 90%; max-height: 80px;">
                            <div v-else>
                              <img  src="../../../assets/images/thumbupload.jpg" style="max-width: 90%; max-height: 50px;">
                              <br clear="all" />
                              <small class="center-align">clique para inserir uma imagem</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress}%`"></div>
                      </div>
                      <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="usuario.parceiro_logo" class="center-align"><i class="material-icons pointer" @click.prevent="destroyImageParceiro()">delete_forever</i></div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <input name="ativo" id="ativo" type="checkbox" v-model="usuario.ativo">
              <label for="ativo">Ativo</label>
            </div>

          </div>

          <div class="row">

            <div class="col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/usuarios/usuarios/form.vue